export const classes = {
  reg: "register-container",
  regC: "register-container__content",
  regCB: "register-container__content-bottom",
  dm: "demo-map",
  dmCS: "demo-map__categories-select",
  dmCL: "demo-map__categories-list",
  dmMCS: "demo-map__categories-mobile-select",
  dmMCL: "demo-map__categories-mobile-list",
  dmI: "demo-map__info",
  aC: 'article-content',
  aCB: 'article-content__body',
  aCBC: 'article-content__body-carousel'
}
